import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=4192cea4&scoped=true&"
import script from "./FileCard.vue?vue&type=script&lang=js&"
export * from "./FileCard.vue?vue&type=script&lang=js&"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=4192cea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4192cea4",
  null
  
)

export default component.exports